<template>
  <div claas="visualcontent">
    <div class="row">
      <perfect-scrollbar class="col-md-8">
        <div class="list-images-container">
          <ul class="list-images" v-if="moments && moments.length > 0">
            <li
              v-for="(moment, index) in moments"
              :key="index"
              :style="{ 'background-image': `url(${moment.thumbnail.url})` }"
              class="moment-item square"
              @click="(e) => visualDetail(e, index)"
            >
              <input
                type="checkbox"
                class="moment-selector"
                :value="moment"
                v-model="selectedMoments"
              />
              <div
                class="content"
                :class="{
                  reject: moment.status == 'rejected',
                  approved: moment.status == 'approved',
                  pending: moment.status == 'pending',
                }"
              >
                <img
                  :src="icons.rejected"
                  class="img-icon"
                  v-if="moment.status == 'rejected'"
                />
                <img
                  :src="icons.published"
                  class="img-icon"
                  v-if="moment.status == 'approved'"
                />
                <img
                  :src="icons.pending"
                  class="img-icon"
                  v-if="moment.status == 'pending'"
                />
              </div>
            </li>
          </ul>
        </div>
        <Pagination
          v-model="page"
          :length="totalPages"
          @change="onPageChange"
          color="#FF3408"
          v-if="hasMoments"
          class="paging"
        />
      </perfect-scrollbar>
      <Pagination
          v-model="page"
          :length="totalPages"
          @change="onPageChange"
          color="#FF3408"
          v-if="hasMoments"
          class="paging-mobile"
        />
      <perfect-scrollbar class="col-md-4">
        <div class="card shadow p-3 mb-5 bg-white rounded">
          <div class="card-body px-2">
            <h5 class="card-title font-weight-bold">Content Options</h5>
            <div class="card-text">
              <div class="row form-group">
                <div class="col-md-4 px-1">
                  <button
                    class="
                      btn btn-secondary btn-block btn-sm
                      sizefont-12
                      action-button
                    "
                    @click="setSelectedMoment('approved')"
                    :disabled="!hasSelectedMoments"
                  >
                    <img :src="icons.published" class="icon icon-approved" />
                    <span>APPPROVE</span>
                  </button>
                </div>
                <div class="col-md-4 px-1">
                  <button
                    class="
                      btn btn-secondary btn-block btn-sm
                      sizefont-12
                      action-button
                    "
                    @click="setSelectedMoment('pending')"
                    :disabled="!hasSelectedMoments"
                  >
                    <img :src="icons.pending" class="icon icon-pending" />
                    <span>UNDECIDED</span>
                  </button>
                </div>
                <div class="col-md-4 px-1">
                  <button
                    class="
                      btn btn-secondary btn-block btn-sm
                      sizefont-12
                      action-button
                    "
                    @click="setSelectedMoment('rejected')"
                    :disabled="!hasSelectedMoments"
                  >
                    <img :src="icons.rejected" class="icon icon-pending" />
                    <span>HIDE</span>
                  </button>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-12 px-0">
                  <button
                    class="btn btn-add-content btn-block"
                    @click="$emit('showVisualForm')"
                  >
                    ADD CONTENT
                  </button>
                </div>
              </div>
              <div class="row form-group">
                <div
                  class="col-md-12"
                  v-cloak
                  @drop.prevent="addFile"
                  @dragover.prevent
                >
                  <div class="drag-drop drag-hover">
                    <div class="mr-4">
                      <img :src="icons.download" class="icon-download" />
                    </div>
                    <div class="ml-4">
                      You can drag and drop images and videos from your computer
                      here...
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card shadow p-3 mb-5 bg-white rounded filters-form">
          <div class="card-body px-2">
            <h5 class="card-title font-weight-bold">Filter Content</h5>
            <form @submit.prevent="onSubmitSearch">
              <div class="card-text">
                <div class="form-group row">
                  <div class="col-md-12">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search content"
                      v-model="searchFilters.search"
                    />
                  </div>
                </div>
                <div class="form-group form-check">
                  <label class="form-control-label" for="exampleCheck1"
                    ><input
                      type="checkbox"
                      class="form-check-input"
                      v-model="searchFilters.onlyShowUserContents"
                    />
                    Only show my own content</label
                  >
                </div>
                <div class="row form-group">
                  <div class="col-md-4 px-1">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-filter btn-block sizefont-12"
                      :class="{
                        active: searchFilters.statuses.indexOf('approved') > -1,
                      }"
                      @click="toggleSelectedStatus('approved')"
                    >
                      Approved
                    </a>
                  </div>
                  <div class="col-md-4 px-1">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-filter btn-block sizefont-12"
                      :class="{
                        active: searchFilters.statuses.indexOf('pending') > -1,
                      }"
                      @click="toggleSelectedStatus('pending')"
                    >
                      Pending
                    </a>
                  </div>
                  <div class="col-md-4 px-1">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-filter btn-block sizefont-12"
                      :class="{
                        active: searchFilters.statuses.indexOf('rejected') > -1,
                      }"
                      @click="toggleSelectedStatus('rejected')"
                    >
                      Hidden
                    </a>
                  </div>
                </div>
                <div class="form-group">
                  <select class="form-control" v-model="searchFilters.sortBy">
                    <option
                      v-for="option of sortOptions"
                      :key="option.key"
                      :value="option.key"
                    >
                      {{ option.value }}
                    </option>
                  </select>
                </div>
                <div
                  class="form-group"
                  v-if="availableHashtags && availableHashtags.length > 0"
                >
                  <select
                    class="form-control"
                    @change="onDropDownHashtagChange"
                  >
                    <option value>All my hashtags</option>
                    <option
                      v-for="(hashtag, index) of availableHashtags"
                      :key="index"
                      :value="hashtag"
                    >
                      {{ hashtag }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <ul class="list-hashtag">
                    <li v-for="(tag, index) of searchFilters.tags" :key="index">
                      {{ tag }}
                      <i
                        class="fas fa-times ml-3"
                        @click="onClickDeleteHashtag(tag)"
                      ></i>
                    </li>
                  </ul>
                </div>
                <div class="form-group">
                  <a href="#" class="btn-reset" @click="resetSelectedHashtag"
                    >reset</a
                  >
                </div>
                <div class="form-group">
                  <select class="form-control">
                    <option value>All Channels</option>
                  </select>
                </div>
                <div class="form-actions row">
                  <div class="col-md-6">
                    <button class="btn btn-primary btn-block" type="submit">
                      <span>APPLY</span>
                      <img :src="icons.approved" />
                    </button>
                  </div>
                  <div class="col-md-6">
                    <button
                      class="btn btn-secondary btn-block"
                      type="reset"
                      @click="onResetSearch"
                    >
                      <span>RESET FILTERS</span>
                      <img :src="icons.reset" />
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </perfect-scrollbar>
    </div>
    <!-- <Loader :show="loading" /> -->
  </div>
</template>

<script>
import iconReject from "@/assets/images/icons/ew-icon_hidden.svg";
import iconPublished from "@/assets/images/icons/ew-icon_published.svg";
import iconApproved from "@/assets/images/icons/ew-icon_approved.svg";
import iconReset from "@/assets/images/icons/ew-icon_reset.svg";
import iconPending from "@/assets/images/icons/ew-icon_undecided.svg";
import download from "@/assets/images/icons/ew-icon_download.svg";
import loader from "@/assets/images/loader.svg";
import Pagination from "@/components/Pagination";
import Loader from "@/components/Loader";
export default {
  name: "visual-content",
  components: {
    Pagination,
    Loader,
  },
  props: {
    images: {
      type: Array,
      default: [],
    },
    limit: {
      type: Number,
      default: 32,
    },
  },
  data() {
    return {
      loading: false,
      page: 1,
      totalPages: 1,
      moments: [],
      icons: {
        rejected: iconReject,
        published: iconPublished,
        pending: iconPending,
        approved: iconApproved,
        reset: iconReset,
        loader,
        download,
      },
      selectedMoments: [],
      availableHashtags: [],
      searchFilters: {
        search: "",
        tags: [],
        onlyShowUserContents: false,
        statuses: [],
        sortBy: "CREATED_AT",
        sortAscending: false,
      },
      sortOptions: [
        {
          key: "CREATED_AT",
          value: "Sort by post created date",
        },
        {
          key: "LIKE_COUNT",
          value: "Sort by post most liked",
        },
      ],
    };
  },
  computed: {
    hasMoments() {
      return this.moments && this.moments.length > 0;
    },
    hasSelectedMoments() {
      return this.selectedMoments && this.selectedMoments.length > 0;
    },
  },
  methods: {
    async loadAvailableHashtags() {
      this.availableHashtags = await this.$repo.moment.getAvailableHashtags();
    },
    async load() {
      this.loading = true;
      const data = await this.$repo.moment.getManagableMoments(
        this.limit,
        this.page,
        this.searchFilters
      );
      const { results, totalPages } = data;
      this.moments = results;
      this.totalPages = totalPages;
      this.loading = false;
      this.$emit("dataLoaded", {
        totalPosts: results.length,
        totalPages: totalPages,
      });
    },
    distinctMoments(moments) {
      const filtered = moments.filter(
        (it, index, arr) =>
          arr.find((a) => a.id === it.id) && arr.indexOf(it) === index
      );
      return filtered;
    },
    prependMoment(moment) {
      this.moments.unshift(moment);
    },
    showVisualForm() {},
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles || droppedFiles.length < 1) return;
      // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
      // [...droppedFiles].forEach((f) => {
      // 	this.images.push(f);
      // });
      this.$emit("dropPic", droppedFiles[0]);
    },
    visualDetail(e, index) {
      if (e.target.classList.contains("moment-selector")) return;

      this.$emit("showVisualDetail", this.moments, index);
    },
    onDropDownHashtagChange(e) {
      if (
        e.target.value &&
        this.searchFilters.tags.indexOf(e.target.value) < 0
      ) {
        this.searchFilters.tags.push(e.target.value);
      }
    },
    onClickDeleteHashtag(hashtag) {
      const index = this.searchFilters.tags.indexOf(hashtag);
      if (index > -1) {
        this.searchFilters.tags.splice(index, 1);
      }
    },
    resetSelectedHashtag() {
      this.searchFilters.tags = [];
    },
    toggleSelectedStatus(status) {
      const index = this.searchFilters.statuses.indexOf(status);
      if (index > -1) {
        this.searchFilters.statuses.splice(index, 1);
      } else {
        this.searchFilters.statuses.push(status);
      }
    },
    setSelectedMoment(status) {
      if (!this.selectedMoments || this.selectedMoments.length < 1) return;

      const ids = this.selectedMoments.map((it) => it.id);

      this.$repo.moment.batchUpdateMomentStatus(ids, status).then((result) => {
        this.selectedMoments.forEach(
          (it) => (it.status = status.toLowerCase())
        );
        this.selectedMoments = [];
      });
    },
    async onSubmitSearch() {
      this.resetMoments();
      await this.load();
    },
    async onResetSearch() {
      this.resetSelectedHashtag = [];
      this.resetMoments();
      await this.load();
    },
    resetMoments() {
      this.moments = [];
      this.page = 1;
      this.totalPages = 1;
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
  },
  async mounted() {
    await this.loadAvailableHashtags();
    await this.load();
  },
};
</script>

<style scoped lang="scss">

.btn {
  padding: 10px;
}
.loader {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.icon-download {
  width: 30px;
}

.list-images {
  .moment-item {
    cursor: pointer;
  }
  .moment-selector {
    position: absolute;
    left: 5px;
    top: 5px;
    width: 20px;
    height: 20px;
  }
  .content {
    .img-icon {
      width: 32px;
    }
  }
}

.action-button {
  img {
    height: 25px;
    margin-right: 5px;
    vertical-align: middle;
  }
}

.filters-form {
  .form-control,
  .form-control-label {
    font-size: 12px;
  }
  .btn {
    img {
      width: 20px;
      vertical-align: middle;
      float: right;
    }
  }

  .btn-filter {
    background-color: #58595b;
    color: white;
    border-radius: 15px;
    & + .btn-filter {
      margin-left: 10px;
    }
    &.active {
      background-color: var(--primary-color);
      border-color: var(--primary-color);
    }
  }
}

@media only screen and (min-width: 768px) {
  .paging-mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .ps {
    height: 50vh;
  }
  .paging {
    display: none;
    margin: 0 auto;
  }
  .paging-mobile {
    margin: 5px auto;
  }
}
</style>
